import { render, staticRenderFns } from "./AdminLogin.vue?vue&type=template&id=b8ca6e56&scoped=true&"
import script from "./AdminLogin.vue?vue&type=script&lang=ts&"
export * from "./AdminLogin.vue?vue&type=script&lang=ts&"
import style0 from "./AdminLogin.vue?vue&type=style&index=0&id=b8ca6e56&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ca6e56",
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QInput,QSelect,QBtn});
